import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { GuruQuote } from '../components/GuruQuote';
import { Courses } from '../components/Courses';
import { About } from '../components/About';
import { SatguruSandesh } from '../components/SatguruSandesh';
import { Books } from '../components/Books';
import { FeaturedIn } from '../components/FeaturedIn';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-[#FFFBF5]" data-id="element-803">
      <Header data-id="element-804" />
      <main data-id="element-805">
        <Hero data-id="element-806" />
        <GuruQuote data-id="element-807" />
        <Courses data-id="element-808" />
        <About data-id="element-809" />
        <SatguruSandesh data-id="element-810" />
        <Books data-id="element-811" />
        <FeaturedIn data-id="element-812" />
      </main>
      <Footer data-id="element-813" />
    </div>;
}